import BaseLayout from '@/layout/BaseLayout'
import activitesMap from './activitesMap'
import CakeMap from './cakeMap'
import routeMap from './routeMap'
import tabbar from './tabbarRoute'

// const RouteView = {
//   name: 'RouteView',
//   render: h => h('router-view')
// }

const routes = [
  {
    path: '/',
    redirect: '/tabbar/home',
    component: BaseLayout,
    children: [
      ...tabbar,
      ...routeMap,
      ...CakeMap,
      ...activitesMap
    ]
  }
]

export default routes